import { toPromptSafeName } from '@/server/domain/prompt-safety'
import { PUBLIC_CHAT_LIMITS } from './limits'

/**
 * El nombre del niño tal y como lo guarda el chat público: recortado a 40 y
 * luego saneado para el prompt (DESIGN › Driving ports, guarda 2); vacío ⇒ sin
 * nombre. Lo usan el servicio (formulario y nombre aprendido) y el alta de
 * perfil al pre-rellenarlo (AC2.3), así que ambos lo ofrecen igual.
 */
export function publicChatChildName(raw: string | null): string | null {
  return toPromptSafeName((raw ?? '').slice(0, PUBLIC_CHAT_LIMITS.maxNameLength)) || null
}
